<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Delete Service</h4>
</div>
<div class="modal-body">
    <p *ngIf="hasReceipts == true">
        Fees have been paid for this service, place service on Hold or Unassign
    </p>

    <p>Are you sure you want to Delete the Service?</p>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" aria-label="Close" data-bs-dismiss="modal" (click)="cancel()" [disabled]="!callCompleted">No</button>
        <button class="btn--accent" type="submit" data-bs-dismiss="modal" (click)="accept()" [disabled]="!callCompleted">Yes</button>
    </div>
</div>
